import { Dispatch } from "redux";

import http from "@api/http";
import { TResponse } from "@api/types";
import { buildFilterQueryString, deserialize } from "@api/jsonApiParser";

import * as constants from "../../../constants";
import { TAction } from "../../../redux/types";

export const SET_EMAILLOGS_PAGE_NO = "SET_EMAILLOGS_PAGE_NO";
export const FETCHED_EMAILLOGS = "FETCHED_EMAILLOGS";
export const INCREMENT_EMAIL_LOG_PAGE_NO = "INCREMENT_EMAIL_LOG_PAGE_NO";

export interface EmailLogsState {
  emailLogs: any;
  emailLogsPageNo: any;
  moreEmailLogs: boolean;
  filter: any;
}

const initialState = {
  emailLogs: [],
  emailLogsPageNo: 1,
  moreEmailLogs: true,
  filter: undefined,
};

export const EmailLogsReducer = (state: EmailLogsState = initialState, action: any) => {
  switch (action.type) {
    case constants.FETCHED_EMAILLOGS: {
      let emailLogs = [];
      const moreEmailLogs = !(action.payload.length < constants.PAGINATION_SIZE);

      if (state.emailLogsPageNo === 1 || action.page === 1) {
        emailLogs = [...action.payload];
      } else {
        emailLogs = [...state.emailLogs, ...action.payload];
      }

      return { ...state, emailLogs: emailLogs, moreEmailLogs: moreEmailLogs };
    }

    case constants.SET_EMAILLOGS_PAGE_NO: {
      const moreEmailLogs = !(
        state.emailLogs.length <
        (state.emailLogsPageNo + 1) * constants.PAGINATION_SIZE
      );
      return { ...state, emailLogsPageNo: action.payload, moreEmailLogs: moreEmailLogs };
    }

    case constants.SET_FILTERING_CRITERIA_EMAILLOGS: {
      if (action.payload === "clearFilter") {
        return {
          ...state,
          filter: undefined,
        };
      } else {
        return { ...state, filter: action.payload.value };
      }
    }

    case INCREMENT_EMAIL_LOG_PAGE_NO: {
      return {
        ...state,
        emailLogsPageNo: state.emailLogsPageNo + 1,
      };
    }
  }
  return state;
};

export const setEmailLogsPageNo = (payload: number): TAction => ({
  type: SET_EMAILLOGS_PAGE_NO,
  payload,
});

export const fetchEmailLogList = (page = 1, pageSize = 10, filter?: Record<string, unknown>) => {
  return async (dispatch: Dispatch): Promise<void> => {
    dispatch({ type: constants.LOADING, payload: true });

    const query = `EmailLog/EmailLogPaginated?Page=${page}&PageSize=${pageSize}`;

    return await http
      .get(filter ? buildFilterQueryString(filter, query) : query)
      .then((response: TResponse) => {
        dispatch({
          type: FETCHED_EMAILLOGS,
          payload: (response.data as Record<string, unknown>[]).map(emailLogList =>
            deserialize(emailLogList)
          ),
          page: page,
        });
        dispatch({ type: constants.LOADING, payload: false });
      });
  };
};

export const incrementEmailLogsPageNo = () => ({
  type: INCREMENT_EMAIL_LOG_PAGE_NO,
});
